<div class="flex justify-between items-center mb-4 mt-4">
  <div class="flex flex-1">
    <div class="flex w-3/5">
      <elcia-search [control]="filterForm.controls.searchTerm"/>
    </div>
  </div>
  <div class="flex flex-1 justify-center">
    <elcia-period-navigator (periodChange)="setPeriod($event)"
                            [initialDate]="periodStore.period().startDate" [periodTypes]="[PeriodType.Month, PeriodType.Quarter, PeriodType.Year]"/>
  </div>
  <div class="flex flex-1 flex-row-reverse gap-2">
    <elcia-button (onClick)="navToForm()" [icon]="'plus'" [label]="'invoice.add' | translate"/>
    <elcia-button (onClick)="runDailyInvoicing()"
                  [disabled]="invoiceStore.runDailyInvoicingMutation.isPending()"
                  [icon]="'bolt'"
                  [isLoading]="invoiceStore.runDailyInvoicingMutation.isPending()"
                  [label]="'invoice.generate' | translate"
                  [severity]="'secondary'"
                  data-testid="generate-invoices"/>
    <elcia-button (onClick)="toggleFilterDisplayed()" [icon]="'filter'" [label]="'app.filters' | translate" [severity]="isFilterDisplayed() ? 'primary' : 'secondary'"
                  ]/>
  </div>
</div>

@if (isFilterDisplayed()) {
  <elcia-filter-container>
    <elcia-party-dropdown [control]="filterForm.controls.customerIds" [isMulti]="true" [partyTypes]="partyTypes()"/>
    <elcia-legal-entity-dropdown [control]="filterForm.controls.legalEntityIds" [isMulti]="true"/>
    <elcia-invoice-state-dropdown [control]="filterForm.controls.stateNames"/>
  </elcia-filter-container>
}

<elcia-invoice-grid (creditRequested)="navToCredit($event)" (deleteRequested)="confirmDelete($event)"
                    (invoiceSelected)="navToEdit($event)"
                    [invoices]="store.invoices()"/>
